import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutSalesCallListTable extends Layout {
    panelSecondaryFilters: Panel;
    sourceSalesCalls: DataSource;
    tableSalesCalls: Table;
}
